module.exports = __webpack_public_path__ + "static/media/moment6.e2321632.jpg";